module.exports = __webpack_public_path__ + "assets/img/textClassification.425b0616.png";